import FallbackLoader from './FallbackLoader';

export default FallbackLoader(() => import(/* webpackChunkName: "async-GenericSuccess" */'shared-components/components/FeedbackModal'));
